import React, {ReactElement} from 'react';
import MComponent from '../../Toolkit/Components/Component';
import {Column} from 'primereact/column';
import MTable, {MTableFilters} from '../../Toolkit/Components/Controls/Table';
import MButton from '../../Toolkit/Components/Controls/Button';
import MToolbar from '../../Toolkit/Components/Controls/Toolbar';
import {MNewIconName, MOpenIconName} from '../../Toolkit/Icons';
import MSpacer from '../../Toolkit/Components/Controls/Spacer';
import {DataTableSortMeta} from 'primereact/datatable';
import EnumContext from '../../Context/enum-context';
import {NoticeDetail} from '../../Api/NoticeTypes';
import WithRouterProps from '../../Toolkit/WithRouterProps';
import {Calendar} from 'primereact/calendar';
import {MDropDownItem} from '../../Toolkit/Components/Controls/DropDownOption';
import MMultiDropDown from '../../Toolkit/Components/Controls/MultiDropDown';
import {FilterMatchMode, FilterService} from 'primereact/api';

type RouteParams = {}

type Props = WithRouterProps<RouteParams> & {
    noticeId: number;
    rowData: NoticeDetail[];
}

/** */
type State = {
    filters: MTableFilters;
    selectedRow?: NoticeDetail;
}

class NoticeDetailListControl extends MComponent<Props, State> {
    static contextType = EnumContext;
    context!: React.ContextType<typeof EnumContext>

    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();
    }

    private bindMethods(): void {
        this.isOpenDisabled = this.isOpenDisabled.bind(this);
        this.new_Click = this.new_Click.bind(this);
        this.open_Click = this.open_Click.bind(this);
        this.table_onSelectionChange = this.table_onSelectionChange.bind(this);
        this.phaseTypeTemplate = this.phaseTypeTemplate.bind(this);
        this.permitStatusTemplate = this.permitStatusTemplate.bind(this);
    }

    private initializeState(): void {
        this.state = {
            filters: {
                'tmType': {
                    value: null,
                    matchMode: FilterMatchMode.CUSTOM
                },
                'subResource': {
                    value: null,
                    matchMode: FilterMatchMode.IN
                },
                'permitType': {
                    value: null,
                    matchMode: FilterMatchMode.IN
                },
                'startDate': {
                    value: null,
                    matchMode: FilterMatchMode.DATE_IS
                },
                'endDate': {
                    value: null,
                    matchMode: FilterMatchMode.DATE_IS
                },
                'permitNumber': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                },
                'submissionDate': {
                    value: null,
                    matchMode: FilterMatchMode.DATE_IS
                },
                'permitStatus': {
                    value: null,
                    matchMode: FilterMatchMode.IN
                }
            }
        };
    }

    private table_onSelectionChange(selection: NoticeDetail | NoticeDetail[] | undefined): void {

        this.safeSetState((draft: State) =>
            draft.selectedRow = selection as NoticeDetail | undefined);

    }

    private new_Click(): void {
        this.props.navigate(`/notices/create/2/${this.props.noticeId}/0`);
    }

    private open_Click(): void {
        this.props.navigate(`/notices/detail/${this.state.selectedRow?.id}`);
    }

    private isOpenDisabled(): boolean {
        return this.state.selectedRow === undefined;
    }

    private startDateTemplate(rowData: NoticeDetail): string | undefined {
        if(rowData.startDate !== null) {
            try {
                return rowData.startDate!.toLocaleDateString();
            } catch {
                return '';
            }
        }
        return '';
    }

    private endDateTemplate(rowData: NoticeDetail): string | undefined {
        if(rowData.endDate !== null) {
            try {
                return rowData.endDate!.toLocaleDateString();
            } catch {
                return '';
            }
        }
        return '';
    }

    private phaseTypeTemplate = (rowData:NoticeDetail) : string => {
        const index = this.context.enums?.phaseTypes.findIndex(value => value.id === rowData.phaseType);

        if(index === undefined || index === -1) {
            return '';
        }

        return this.context.enums?.phaseTypes[index!].name ?? '';
    }

    private permitStatusTemplate = (rowData:NoticeDetail) : string => {
        const index = this.context.enums?.permitStates.findIndex(value => value.id === rowData.permitStatus);

        if(index === undefined || index === -1) {
            return '';
        }

        return this.context.enums?.permitStates[index!].name ?? '';
    }

    private tableSortTemplate(): DataTableSortMeta[] {
        return [
            {field: 'odinId', order: 1}
        ];
    }

    private submissionDateTemplate = (rowData: NoticeDetail): string => {
        if(rowData.submissionDate != null) {
            try {
                return rowData.submissionDate.toLocaleDateString();
            } catch {
                return '';
            }
        }
        return '';
    };

    private tmTypeTemplate = (rowData:NoticeDetail) : string => {
        let tmNames : string = "";
        for(let counter: number = 0; counter < rowData.tmType.length; counter++)
        {
            const index = this.context.enums?.tmTypes.findIndex(value => value.id === rowData.tmType[counter]);

            if(index !== undefined || index !== -1) {
                tmNames += this.context.enums?.tmTypes[index!].name ?? '';
            }

            if((counter + 1) < rowData.tmType.length)
            {
                tmNames += ", ";
            }
        }

        return tmNames;
    }

    private subResourceTemplate = (rowData:NoticeDetail) : string => {
        const index = this.context.enums?.subResources.findIndex(value => value.id === rowData.subResource);

        if(index !== undefined || index !== -1) {
            return this.context.enums?.subResources[index!].name ?? '';
        }

        return '';
    }

    private permitTypeTemplate = (rowData:NoticeDetail) : string => {
        const index = this.context.enums?.permitTypes.findIndex(value => value.id === rowData.permitType);

        if(index !== undefined || index !== -1) {
            return this.context.enums?.permitTypes[index!].name ?? '';
        }

        return '';
    }

    private dateFilterTemplate = (options: any) => {
        return <Calendar value={options.value}
                         onChange={(e: any) => options.filterApplyCallback(e.value, options.index)}
                         dateFormat="dd/mm/yy"
                         placeholder="dd/mm/yyyy"
                         mask="99/99/9999"/>;
    };

    private tmTypeFilterTemplate = (options: any) => {
        if(this.context.enums === null) {
            return <div></div>;
        }

        const itemList: MDropDownItem<number>[] = (
            this.context.enums!.tmTypes
                               .map((enumValue) => {
                                   return {label: enumValue.name, value: enumValue.id};
                               })
        );

        return (
            <MMultiDropDown id="tmTypeFilter"
                            items={itemList}
                            disabled={false}
                            onChange={(selection: number[]) => options.filterApplyCallback(selection)}/>
        );
    }


    private permitTypeFilterTemplate = (options: any) => {
        if(this.context.enums === null) {
            return <div></div>;
        }

        const itemList: MDropDownItem<number>[] = (
            this.context.enums!.permitTypes
                               .map((enumValue) => {
                                   return {label: enumValue.name, value: enumValue.id};
                               })
        );

        return (
            <MMultiDropDown id="permitTypeFilter"
                            items={itemList}
                            disabled={false}
                            onChange={(selection: number[]) => options.filterApplyCallback(selection)}/>
        );
    }

    private permitStatusFilterTemplate = (options: any) => {
        if(this.context.enums === null) {
            return <div></div>;
        }

        const itemList: MDropDownItem<number>[] = (
            this.context.enums!.permitStates
                               .map((enumValue) => {
                                   return {label: enumValue.name, value: enumValue.id};
                               })
        );

        return (
            <MMultiDropDown id="permitStateFilter"
                            items={itemList}
                            disabled={false}
                            onChange={(selection: number[]) => options.filterApplyCallback(selection)}/>
        );
    }

    private subResourceFilterTemplate = (options: any) => {
        if(this.context.enums === null) {
            return <div></div>;
        }

        const itemList: MDropDownItem<number>[] = (
            this.context.enums!.subResources
                               .map((enumValue) => {
                                   return {label: enumValue.name, value: enumValue.id};
                               })
        );

        return (
            <MMultiDropDown id="subResourceFilter"
                            items={itemList}
                            disabled={false}
                            onChange={(selection: number[]) => options.filterApplyCallback(selection)}/>
        );
    }

    public render(): ReactElement {
        //The rule parameter needs to be in the format 'custom_[fieldName]
        FilterService.register('custom_tmType', (value: Array<number>, filters: Array<number>) => {
            if(filters === null || filters.length === 0) return true;
            return filters.some(item => value.includes(item));
        });

        return (
            <div>
                <MToolbar>
                    <MButton label="Add"
                             color="success"
                             icon={MNewIconName}
                             disabled={false}
                             onClick={this.new_Click}/>
                    <MSpacer/>
                    <MButton label="Open"
                             icon={MOpenIconName}
                             disabled={this.isOpenDisabled}
                             onClick={this.open_Click}/>
                </MToolbar>
                <MTable
                    rowKey="id"
                    rowData={this.props.rowData}
                    filters={this.state.filters}
                    onSelectionChange={this.table_onSelectionChange}
                    sortMode={'multiple'}
                    multiSortMeta={this.tableSortTemplate()}>

                    <Column field="tmType"
                            header="TM Type"
                            filter={true}
                            filterElement={this.tmTypeFilterTemplate}
                            showClearButton={false}
                            showFilterMenu={false}
                            sortable={true}
                            body={this.tmTypeTemplate}
                            style={{width: '12%'}}/>
                    <Column field="startDate"
                            header="Start Date"
                            dataType="date"
                            filter={true}
                            filterElement={this.dateFilterTemplate}
                            sortable={true}
                            body={this.startDateTemplate}
                            style={{width: '12%'}}/>
                    <Column field="endDate"
                            header="End Date"
                            dataType="date"
                            filter={true}
                            filterElement={this.dateFilterTemplate}
                            sortable={true}
                            body={this.endDateTemplate}
                            style={{width: '12%'}}/>
                    <Column field="subResource"
                            header="Sub Resource"
                            filter={true}
                            filterElement={this.subResourceFilterTemplate}
                            showClearButton={false}
                            showFilterMenu={false}
                            sortable={true}
                            body={this.subResourceTemplate}
                            style={{width: '18%'}}/>
                    <Column field="permitNumber"
                            header="Permit Number"
                            filter={true}
                            sortable={true}
                            style={{width: '18%'}}/>
                    <Column field="permitType"
                            header="Permit Type"
                            filter={true}
                            filterElement={this.permitTypeFilterTemplate}
                            showClearButton={false}
                            showFilterMenu={false}
                            sortable={true}
                            body={this.permitTypeTemplate}
                            style={{width: '12%'}}/>
                    <Column field="submissionDate"
                            header="Submission Date"
                            dataType="date"
                            filter={true}
                            filterElement={this.dateFilterTemplate}
                            sortable={true}
                            body={this.submissionDateTemplate}
                            style={{width: '12%'}}/>
                    <Column field="permitStatus"
                            header="Permit Status"
                            filter={true}
                            filterElement={this.permitStatusFilterTemplate}
                            showClearButton={false}
                            showFilterMenu={false}
                            sortable={true}
                            body={this.permitStatusTemplate}
                            style={{width: '12%'}}/>
                </MTable>
            </div>
        );
    }
}

export default NoticeDetailListControl;